/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {Device, Devices} from '@ion/core/src/types/entities';
import DeviceChip from './DeviceChip';

// defines the prop definitions for Device chips editor ...
export interface DeviceChipsProps {
  chipWrapperClass: string;
  devices: Devices;
  onDelete: (device: Device) => void;
};

export const DeviceChips = ({devices, onDelete, chipWrapperClass}: DeviceChipsProps) => {
  if (devices?.length) {
    const isDelete = devices.length > 2;
    return (
      <>
        {devices.map((device: Device) => (
          <DeviceChip classes={chipWrapperClass}
            device={device}
            isDelete={isDelete}
            onDelete={onDelete} />
        ))}
      </>
    );
  }
};
export default DeviceChips;
